import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CategoriesData from "../../models/CategoriesData";
import Title from "../common/TitleComponent";
import { Link } from "react-router";

import { motion } from "framer-motion";
import { fadeIn } from "../animation/Variants";

const MainTreatmentCategorySlider = () => {
  const settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    dots: false,
    infinite: true,
    initialSlide: 0,
    slidesToShow: 4,
    slidesToScroll: 1,
    // speed: 1500,
    speed: 1000,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          dots: false,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: false,
          slidesToShow: 1,
        }
      }
    ]
  };
  return (

    <>
      <div className="w-full">
        <Title
          Title={"Main Treatment Categories"}
          Subtitle={"All the treatments are grouped into main categories."}
        />

          <Slider {...settings}>

            {CategoriesData.map((item) => (

              <div className="w-full" key={item.id}>
                <div className="featured-imagebox featured-imagebox-service style1">
                  <div className="featured-thumbnail">
                    <img
                      className="w-full h-72"
                      src={item.src}
                      alt={item.alt}
                    />
                  </div>
                  <Link to={`/Treatments/${item.title}`}>
                    <div className="featured-content slick_title">
                      <div className="featured-title">
                        <h3 className="title_DMSerifText-Regular">

                          {item.title}
                        </h3>
                      </div>
                      <div className="featured-desc">
                        <p> {item.subtitle} </p>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>

            ))}

          </Slider>
     
      </div>
    </>
  );
}

export default MainTreatmentCategorySlider;
